import { useOutletContext, useNavigate } from "react-router-dom";
import Sprints from "@/components/Sprints";

export default function SprintsPage() {
  const ctx = useOutletContext();
  const navigate = useNavigate();
  return (
    <div data-testid="sprints-page">
      <div className="mb-4 flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-slate-500">{ctx.project.workspace_name}</div>
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-2">Sprints</h1>
          <p className="text-slate-500 mt-1">Planeje, inicie e acompanhe ciclos de trabalho.</p>
        </div>
      </div>
      <Sprints projectId={ctx.projectId} columns={ctx.columns} refreshKey={ctx.refreshKey}
        onOpenTask={ctx.openTask} onChanged={ctx.bump} onGoKanban={() => navigate(`/projetos/${ctx.projectId}/kanban`)} />
    </div>
  );
}
